import { useQuery } from '@tanstack/react-query';

import { getStorefrontPicks, searchStorefront } from 'api/jalapeno';
import useAccountQuery from 'api/queries/useAccountQuery';

export const SEARCH_QUERY_KEY = 'search';

const useSearchQuery = (searchQuery) => {
    const { data: account = {} } = useAccountQuery();

    const query = useQuery({
        queryKey: [SEARCH_QUERY_KEY, searchQuery],
        queryFn: async ({ signal }) => {
            if (searchQuery !== '') {
                const response = await searchStorefront(account?.nextOrder?.chargeID, searchQuery, { signal });

                if (response?.data?.items?.length > 0) {
                    return {
                        ...response?.data,
                        noResults: false,
                    };
                }
            }

            const recommendations = await getStorefrontPicks(account?.nextOrder?.chargeID);
            return {
                items: recommendations?.data?.recommendations,
                noResults: true,
            };
        },
        enabled: !!account?.nextOrder?.chargeID,
    });

    return query;
};

export default useSearchQuery;
